var _path, _path2, _g, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _path8, _g7, _path9, _g8, _path0, _g9, _path1, _g0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJustSaladLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 24,
    viewBox: "0 0 113 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_742_8548)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.704 1.49243H37.6071V5.05167H35.8926V7.72789H37.6071V15.0531C37.6071 18.0381 39.2198 19.0417 41.4974 19.0417C42.6493 19.0417 43.5197 18.7844 44.2874 18.3468V15.7994C43.6731 16.1081 43.059 16.2627 42.3678 16.2627C41.3186 16.2627 40.704 15.7737 40.704 14.5643V7.72789H44.3384V5.05167H40.704V1.49243Z",
    fill: "#15284B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.57153 2.76483H6.68016V0H3.57153V2.76483Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.58331 19.4596C3.58331 20.669 2.96873 21.1579 1.91953 21.1579C1.22839 21.1579 0.614235 21.0034 -6.10352e-05 20.6947V23.2421C0.767633 23.6796 1.63802 23.937 2.78991 23.937C5.06757 23.937 6.68007 22.9334 6.68007 19.9484V5.05151H3.58331V19.4596Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9021 10.756C56.3153 10.2413 54.8564 9.8295 54.8564 8.85175V8.80034C54.8564 8.00266 55.5476 7.4366 56.7502 7.4366C57.8766 7.4366 59.2586 7.92541 60.5639 8.72309L61.7924 6.51012C60.3592 5.55807 58.5164 4.96631 56.8271 4.96631C54.1399 4.96631 52.0153 6.53582 52.0153 9.10922V9.16063C52.0153 11.7594 54.2421 12.5828 56.2383 13.149C57.8252 13.6378 59.2586 13.9983 59.2586 15.0531V15.1048C59.2586 16.0053 58.4909 16.5714 57.1598 16.5714C55.7779 16.5714 54.1911 16.0053 52.7323 14.8989L51.35 17.0089C53.0392 18.3468 55.1638 19.0417 57.0832 19.0417C59.8985 19.0417 62.0996 17.6265 62.0996 14.7701V14.7187C62.0996 12.2741 59.8728 11.3736 57.9021 10.756Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.137 18.7843H82.2342V0H79.137V18.7843Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.98 16.3654C103.881 16.3654 102.09 14.6671 102.09 11.9909C102.09 9.26343 103.856 7.61652 105.98 7.61652C108.053 7.61652 109.896 9.34069 109.896 11.9909C109.896 14.6414 108.053 16.3654 105.98 16.3654ZM109.845 0V7.30779C108.872 6.04701 107.464 4.9146 105.238 4.9146C102.013 4.9146 98.9673 7.4623 98.9673 11.9909C98.9673 16.52 102.064 19.0674 105.238 19.0674C107.439 19.0674 108.846 17.9351 109.845 16.52V18.7843H112.941V0H109.845Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4556 9.69236C19.4129 9.78879 18.9425 16.5554 15.605 16.5554C12.2674 16.5554 11.7971 9.78879 11.7545 9.69236C11.7125 9.59778 11.646 9.60275 11.5446 9.57804C11.3461 9.52976 9.94761 8.98642 8.94586 8.38159C8.94586 12.0658 10.9989 18.9189 15.2434 18.9189H15.605H15.9667C20.2111 18.9189 22.2642 12.0658 22.2642 8.38159C21.2624 8.98642 19.8639 9.52976 19.6655 9.57804C19.564 9.60275 19.4975 9.59778 19.4556 9.69236Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.0011 15.1622C72.3053 15.9435 71.3929 16.3341 70.2634 16.3341C69.2063 16.3341 68.3297 15.9299 67.6341 15.1213C66.9563 14.322 66.6176 13.2865 66.6176 12.0145C66.6176 10.8246 66.9654 9.82524 67.6612 9.01677C68.3659 8.21738 69.2422 7.81762 70.2906 7.81762C71.4019 7.81762 72.3053 8.2127 73.0011 9.00299C73.6968 9.81161 74.0447 10.8382 74.0447 12.0827C74.0447 13.3273 73.6968 14.3539 73.0011 15.1622ZM73.8549 6.95902C72.6352 5.68744 71.2571 5.05151 69.7213 5.05151C67.9411 5.05151 66.4594 5.71471 65.2759 7.04082C64.0919 8.36735 63.5002 10.0251 63.5002 12.0145C63.5002 14.0404 64.0919 15.73 65.2759 17.0836C66.4685 18.41 67.9773 19.0731 69.8024 19.0731C71.2479 19.0731 72.599 18.4824 73.8549 17.3015V18.6915H76.918V5.41947H73.8549V6.95902Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.3992 15.1622C92.7034 15.9435 91.7909 16.3341 90.6615 16.3341C89.6044 16.3341 88.7278 15.9299 88.0321 15.1213C87.3544 14.322 87.0157 13.2865 87.0157 12.0145C87.0157 10.8246 87.3635 9.82524 88.0593 9.01677C88.764 8.21738 89.6403 7.81762 90.6885 7.81762C91.8 7.81762 92.7034 8.2127 93.3992 9.00299C94.0949 9.81161 94.4428 10.8382 94.4428 12.0827C94.4428 13.3273 94.0949 14.3539 93.3992 15.1622ZM94.2529 6.95902C93.0332 5.68744 91.6552 5.05151 90.1194 5.05151C88.3392 5.05151 86.8575 5.71471 85.674 7.04082C84.49 8.36735 83.8983 10.0251 83.8983 12.0145C83.8983 14.0404 84.49 15.73 85.674 17.0836C86.8665 18.41 88.3754 19.0731 90.2005 19.0731C91.646 19.0731 92.9971 18.4824 94.2529 17.3015V18.6915H97.3161V5.41947H94.2529V6.95902Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.34551 6.94368C9.5701 6.5692 10.6264 5.64342 15.5782 5.64342C17.7184 5.64342 19.9958 6.07585 19.9958 6.60939C19.9958 7.14321 17.7184 7.57578 15.5782 7.57578C13.9209 7.57578 12.2088 7.25682 11.4805 6.95149C11.0847 6.78548 10.8552 6.80394 10.723 6.86984C10.5957 6.93331 10.5868 7.11367 10.7043 7.19419C12.1848 8.2083 15.5782 8.2526 15.5782 8.2526C19.2175 8.2526 22.1676 7.51698 22.1676 6.60939C22.1676 5.70193 19.2175 4.96631 15.5782 4.96631C9.14197 4.96631 9.04253 6.85137 9.14452 6.96626C9.20045 7.02917 9.30215 7.01597 9.34551 6.94368Z",
    fill: "#15284B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_742_8548",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 113,
    height: 24
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23.9369H112.941V0H0V23.9369Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_742_8548)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0825 10.756C28.4957 10.2413 27.0368 9.8295 27.0368 8.85175V8.80034C27.0368 8.00266 27.728 7.4366 28.9306 7.4366C30.0571 7.4366 31.439 7.92541 32.7443 8.72309L33.9728 6.51012C32.5397 5.55807 30.6968 4.96631 29.0076 4.96631C26.3203 4.96631 24.1957 6.53582 24.1957 9.10922V9.16063C24.1957 11.7594 26.4226 12.5828 28.4187 13.149C30.0056 13.6378 31.439 13.9983 31.439 15.0531V15.1048C31.439 16.0053 30.6712 16.5714 29.3402 16.5714C27.9584 16.5714 26.3716 16.0053 24.9126 14.8989L23.5305 17.0089C25.2195 18.3468 27.3441 19.0417 29.2637 19.0417C32.0789 19.0417 34.28 17.6265 34.28 14.7701V14.7187C34.28 12.2741 32.0532 11.3736 30.0825 10.756Z",
    fill: "#15284B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_742_8548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJustSaladLogo);
export default __webpack_public_path__ + "static/media/just-salad-logo.9a5815de462468dc38409c3b45cb7afc.svg";
export { ForwardRef as ReactComponent };